import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-company-vehicle-edit-modal',
  templateUrl: './company-vehicle-edit-modal.component.html',
  styleUrls: ['./company-vehicle-edit-modal.component.css']
})
export class CompanyVehicleEditModalComponent implements OnInit {
  @Input() vehicle: any;
  @Output() onCloseModal = new EventEmitter<string>();
  @Output() onSave = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  onSaveVehicle(evt: any) {
    this.onSave.emit(evt);
  }

  closeModal() {
    this.onCloseModal.emit();
  }
}